import React, { useCallback, useEffect, useState } from "react";
import { Accordion, Spinner } from "react-bootstrap";
import { useDispatch } from "react-redux";
import { Signupfaq } from "../../services/SEOServices";
import { FailureModalShow } from "../../Store/Action/Action";
import * as classes from "./Login.module.scss";

const Faq = () => {
  const [isLoadMore, setisLoadMore] = useState(true);
  const [FaqTotalLength, setFaqTotalLength] = useState();
  const [FaqData, setFaqData] = useState([]);
  const dispatch = useDispatch();
  const getFaq = useCallback(
    (value) => {
      if (value) {
        setTimeout(() => {
          Signupfaq()
            .then((response) => {
              var data;
              setFaqTotalLength(response.data.data.length);
              if (FaqData.length !== 0) {
                data = response.data.data.slice(
                  FaqData.length,
                  FaqData.length + 3
                );
              } else {
                data = response.data.data.slice(0, 3);
              }
              setFaqData((pre) => [...pre, ...data]);
              setisLoadMore(false);
            })
            .catch((error) => {
              dispatch(
                FailureModalShow({
                  show: true,
                  msg: error.message,
                })
              );
            });
        }, 1000);
      }
    },
    [FaqData]
  );

  useEffect(() => {
    getFaq(true);
  }, []);
  return (
    <div className="mainsec">
      <div className="headerSec">
        <h1>FAQs</h1>
      </div>

      <div className={classes.faqQuestion}>
        <Accordion>
          {FaqData?.map((item, index) => (
            <Accordion.Item eventKey={index}>
              <Accordion.Header>Q. {item.question}</Accordion.Header>
              <Accordion.Body>{item.answer}</Accordion.Body>
            </Accordion.Item>
          ))}
        </Accordion>
      </div>
      {FaqData.length < FaqTotalLength && FaqData.length >= 3 && (
        <div className={classes.loadMore}>
          {!isLoadMore ? (
            <button
              className={classes.loadSec}
              onClick={() => {
                setisLoadMore(true);
                getFaq(true);
              }}
            >
              <i className={classes.loadIcon}></i> <p>LOAD MORE</p>
            </button>
          ) : (
            <div>
              <Spinner animation="border" size="md" />
            </div>
          )}
        </div>
      )}
    </div>
  );
};

export default Faq;
